import PaletteGrid from '../PaletteGrid';
import PaletteInfo from '../PaletteInfo';
import { useMapStore } from '@/store/useMapStore';

const PaletteTab = () => {
  const { selectedPalette, palettes } = useMapStore();
  const palette = palettes.find(p => p.id === selectedPalette);

  return (
    <div className="p-6 space-y-4" style={{ backgroundColor: '#F0EBE3' }}>
      <div>
        <h3 style={{
          fontFamily: "var(--font-heading)",
          fontSize: '1.75rem',
          color: 'var(--brand-text)',
        }}>
          Color Palette
        </h3>
        {palette && (
          <p style={{
            fontFamily: "var(--font-heading)",
            fontSize: '1.1rem',
            color: 'var(--brand-muted)',
            marginTop: '2px',
          }}>
            {palette.displayName}
          </p>
        )}
      </div>
      <PaletteGrid />
      <PaletteInfo />
    </div>
  );
};

export default PaletteTab;
